// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__rTIRo","project":"Projects_project__Oif2k","p1":"Projects_p1__T4KR6","p2":"Projects_p2__BUycB"};